import React from 'react';

import './style.css';

const Header = () => {
  return (
    <header>
      <h1 className="app-header">Solve The Wordle</h1>
    </header>
  );
}

export default Header;